import { render, staticRenderFns } from "./ClientEntryLinksModal.vue?vue&type=template&id=2516c1c4&scoped=true"
import script from "./ClientEntryLinksModal.vue?vue&type=script&lang=js"
export * from "./ClientEntryLinksModal.vue?vue&type=script&lang=js"
import style0 from "./ClientEntryLinksModal.vue?vue&type=style&index=0&id=2516c1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516c1c4",
  null
  
)

export default component.exports